/** One From row from `GET …/auth/session/validate/:id` → `data.email_integration_data`. */
export interface EmailIntegrationFromOption {
  email: string;
  name: string;
}

export const DEFAULT_COMPOSE_FROM_EMAIL = 'notifications@ceipalmail.com';

/** Normalize API / storage rows; drops invalid entries. */
export function normalizeEmailIntegrationData(raw: unknown): EmailIntegrationFromOption[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  const out: EmailIntegrationFromOption[] = [];
  const seen = new Set<string>();
  for (const item of raw) {
    if (item == null || typeof item !== 'object' || Array.isArray(item)) {
      continue;
    }
    const rec = item as Record<string, unknown>;
    const email = typeof rec['email'] === 'string' ? rec['email'].trim() : '';
    const name = typeof rec['name'] === 'string' ? rec['name'].trim() : '';
    if (!email) {
      continue;
    }
    const key = email.toLowerCase();
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    out.push({ email, name: name || email });
  }
  return out;
}

export function defaultEmailIntegrationFallback(displayName: string): EmailIntegrationFromOption[] {
  const name = displayName.trim() || 'Ceipal';
  return [{ email: DEFAULT_COMPOSE_FROM_EMAIL, name }];
}
